import { render, staticRenderFns } from "./FooterTransparent.vue?vue&type=template&id=ef072a48&scoped=true&"
import script from "./FooterTransparent.vue?vue&type=script&lang=js&"
export * from "./FooterTransparent.vue?vue&type=script&lang=js&"
import style0 from "./FooterTransparent.vue?vue&type=style&index=0&id=ef072a48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef072a48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VFooter,VIcon,VRow})
